import En from './en'
import Zh from './zh'
import ZHH from './zh-h'

const messages = {
  'en': En,
  'zh': Zh,
  'zh-h': ZHH
};

export default messages;